$shm_hitalama_app_overlay $mol_view
	hide_popover null
	show_popover* null
	fullscreen_zoom? 1
	sub /
		<= Overlayed_map_holder $mol_view
			sub <= overlayed_map_visible /
				<= Overlayed_map $shm_hitalama_map_overlayed
					entity <= overlayed_map_entity null
		<= Quick_access $shm_hitalama_profile_quick
		<= Notifications $shm_hitalama_notifications
		^ fullscreen_panel / <= Fullscreen_panel $mol_view
			sub /
				<= Fullscreen_close $mol_link_iconed
					sub /
						<= Fullscreen_close_icon $mol_icon_arrow_expand_all
					uri <= fullscreen_close_uri \
				<= Fullscreen_zoom_out $mol_button_minor
					hint \Уменьшить масштаб
					click? <=> fullscreen_zoom_out? null
					sub / <= Fullscreen_zoom_out_icon $mol_icon_magnify_minus
				<= Fullscreen_zoom_in $mol_button_minor
					hint \Увеличить масштаб
					click? <=> fullscreen_zoom_in? null
					sub / <= Fullscreen_zoom_in_icon $mol_icon_magnify_plus
